import useQueryParams from "hooks/useQueryParams";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { fromB64 } from "utils/base64";
import { dataUsuario } from "../../redux/actions/aLogin";

const LoginF2M = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { payload } = useQueryParams();
  const init = () => {
    debugger;
    const payloadData = fromB64(payload);
    if (payloadData) {
      const { nombres, correo, cliCodigoCore, usu_tipo_usuario, userIsLoggedIn } =
        payloadData?.perfil;
      if (!!nombres & !!correo & !!cliCodigoCore & !!usu_tipo_usuario & !!userIsLoggedIn) {
        dispatch(
          dataUsuario({
            ...payloadData?.perfil,
            jwtRaw: payloadData?.jwtRaw,
            jwtDecoded: payloadData?.jwtDecoded,
            sso: true,
          })
        );
        return history.push("/");
      } else {
        return history.push("/sso/error?code=invalid_user_mdd");
      }
    }
  };
  useEffect(() => {
    init();
  }, []);
  return <React.Fragment></React.Fragment>;
};
export default LoginF2M;
